import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useFunnel } from "../context/FunnelContext";
import { QuizOption } from "./QuizOption";
import { MicroMessage } from "./MicroMessage";
import { ProgressBar } from "./ProgressBar";
import { StepHeader } from "./StepHeader";

export const QuestionFlow = ({ questions, stepNumber, nextRoute, pageTestId }) => {
  const [index, setIndex] = useState(0);
  const [showMicro, setShowMicro] = useState(false);
  const { setAnswer } = useFunnel();
  const navigate = useNavigate();
  const current = questions[index];

  const handleSelect = (option) => {
    setAnswer(current.key, option);
    setShowMicro(true);
    setTimeout(() => {
      setShowMicro(false);
      if (index < questions.length - 1) {
        setIndex((i) => i + 1);
      } else {
        navigate(nextRoute);
      }
    }, 1400);
  };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
      data-testid={pageTestId}
      className="min-h-screen px-6 py-28 flex items-center justify-center bg-[#FBF9F5]"
    >
      <ProgressBar step={stepNumber} total={6} />
      <div className="max-w-xl w-full">
        <StepHeader step={stepNumber} total={6} label={`Question ${index + 1} of ${questions.length}`} />
        <AnimatePresence mode="wait">
          {!showMicro ? (
            <motion.div
              key={current.key}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.4 }}
            >
              <h2 className="font-serif text-2xl sm:text-3xl text-[#1E2D24] mb-8">{current.question}</h2>
              <div className="space-y-4">
                {current.options.map((opt, i) => (
                  <QuizOption
                    key={opt}
                    text={opt}
                    index={i}
                    testId={`quiz-option-${index}-${i}`}
                    onClick={() => handleSelect(opt)}
                  />
                ))}
              </div>
            </motion.div>
          ) : (
            <MicroMessage message={current.micro} />
          )}
        </AnimatePresence>
      </div>
    </motion.main>
  );
};
